(function(){
    'use strict';

    angular
    .module('appback')
    .controller('ProtesController', ProtesController)
 
    ProtesController.$inject = ["GenerallabService","ProtesService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function ProtesController(GenerallabService,ProtesService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.loading = false;
        vm.items = 0;
        vm.maxPages = 0;
        vm.generalLab = GenerallabService;

	    vm.getSelectedItemsIncluding = function(list, item) {
	      item.selected = true;
	      return list.items.filter(function(item) { return item.selected; });
	    };

	    vm.onDragstart = function(list, event) {
	       list.dragging = true;
	       if (event.dataTransfer.setDragImage) {
	         var img = new Image();
	         img.src = 'framework/vendor/ic_content_copy_black_24dp_2x.png';
	         event.dataTransfer.setDragImage(img, 0, 0);
	       }
	    };

	    /**
	     * In the dnd-drop callback, we now have to handle the data array that we
	     * sent above. We handle the insertion into the list ourselves. By returning
	     * true, the dnd-list directive won't do the insertion itself.
	     */
	    vm.onDrop = function(list, items, index) {
	      angular.forEach(items, function(item) { item.selected = false; });
	      list.items = list.items.slice(0, index)
	                  .concat(items)
	                  .concat(list.items.slice(index));
	    	//console.log(list.items);
	      return true;
	    }

	    /**
	     * Last but not least, we have to remove the previously dragged items in the
	     * dnd-moved callback.
	     */
	    vm.onMoved = function(list) {
	    	//console.log("moved");
	      list.items = list.items.filter(function(item) { return !item.selected; });
	    };

	    vm.maquinas = [];
	    vm.protes = { buscados: { dragging: false, items:[] }, pendientes: { dragging: false, items:[] }, secs: [] };

	    vm.buscarProtes = function(){
	    	if(vm.buscador){
		    	vm.loading = true;
		    	ProtesService.getProtesSec(vm.buscador,function(data){
		    		vm.protes.buscados.items = data.protesPend;
		    		vm.loading = false;
				});
		    }
	    }

	    vm.estalleno = function(sec){
	    	//console.log(sec);
	    	var contador = 0;
	    	for(var cont2=0;cont2<sec.sec.items.length;cont2++){
	    		if(sec.sec.items[cont2].lims_id){
	    			contador++;
	    		}
			}
			return (contador==sec.tras ? true : false);
	    }

	     vm.contadorLLeno = function(sec){
	    	var contador = 0;
	    	for(var cont2=0;cont2<sec.sec.items.length;cont2++){
	    		if(sec.sec.items[cont2].lims_id){
	    			contador++;
	    		}
			}
			return contador;
	    }

	    vm.getProtesPend = function(){
	    	vm.loading = true;
	    	ProtesService.getProtesSec(vm.buscador,function(data){
	    		vm.maquinas = data.maquinas;
	    		for(var cont=0;cont<vm.maquinas.length;cont++){
		    		for(var cont3=0;cont3<vm.maquinas[cont].secs.length;cont3++){
		    			if(typeof(vm.maquinas[cont].secs[cont3].sec)=='undefined'){
			    			vm.maquinas[cont].secs[cont3].sec = { dragging: false, items:[]};
			    		}
			    		////console.log("secs1",vm.maquinas[cont].secs[cont3].sec.items.length);
			    		////console.log("secs",vm.maquinas[cont].secs[cont3].tras);
			    		if(vm.maquinas[cont].secs[cont3].sec.items.length<vm.maquinas[cont].secs[cont3].tras){
			    			////console.log("SI");
			    			for(var cont2=0;cont2<vm.maquinas[cont].secs[cont3].tras;cont2++){
			    				if(typeof(vm.maquinas[cont].secs[cont3].sec.items[cont2]) == 'undefined'){
				    				vm.maquinas[cont].secs[cont3].sec.items.push({});
				    			}
			    			}
			    		}
		    		}
		    	}
	    		vm.protes.pendientes.items = data.protesPend;
	    		vm.loading = false;
	    		//vm.items = data.items;
				//vm.maxPages = data.maxPages;
			});
	    }

	    vm.getRand = function(list){
	    	var lenghtProtes = vm.protes.pendientes.items.length;
	    	var contEmp = vm.contadorLLeno(list);
	    	for(var cont=0;cont< list.tras && vm.protes.pendientes.items.length>0;cont++){
		        if(!list.sec.items[cont].lims_id){
			        list.sec.items[cont] = vm.protes.pendientes.items[0];
			        vm.protes.pendientes.items.splice(0,1);//.items.push(vm.protes.pendientes.items[0]);
		    	}
		    }
	    }

	    vm.changeSelect = function(item,index){
	    	if(vm.secSelected && !vm.selected.lims_id){
	    		for(var cont=0;cont<vm.secSelected.sec.items.length;cont++){
	    			if(vm.secSelected.sec.items[cont] == vm.selected){
	    				vm.secSelected.sec.items[cont] = { lims_id : item.lims_id, id: item.id, urgente:item.urgente };
		    			vm.protes.pendientes.items.splice(index,1);//.items.push(vm.protes.pendientes.items[0]);
	    			}
	    		}
	    	}

	    }

	    vm.borrarPendiente = function(list,index,sec){
	    	vm.protes.pendientes.items.push(list.items[index]);
		    //list.items.splice(index,1);//.items.push(vm.protes.pendientes.items[0]);
		    list.items[index] = {};
	        vm.selected = list.items[index];
	        vm.secSelected = sec;
	        list.items[index].selected = true;

	    }

	    vm.guardarInfosec = function(sec,maquinacodigo){
	    	//console.log("maquina",maquinacodigo);
	    	var itemsSim = {id_gel: sec.sec.id_gel, user_hecho:sec.sec.user_hecho, user_arreglado:sec.sec.user_arreglado,striscia: sec.Striscia, data: sec.Data, maquinacodigo:maquinacodigo};
	    	ProtesService.guardarInfoSec(itemsSim,function(data){
	    		//sec.disabled = true;
			});
	    }

	    vm.guardarSec = function(sec,maquinacodigo){
	    	var itemsSim = [];

	    	for(var cont=0;cont<sec.sec.items.length;cont++){
	    		itemsSim.push({ striscia: sec.Striscia, tras:(cont+1), lims_id:sec.sec.items[cont].lims_id, data: sec.Data, maquinacodigo:maquinacodigo });
	    	}

	    	ProtesService.guardarStric(itemsSim,function(data){
	    		sec.disabled = true;
			});
	    	//console.log(itemsSim);
	    }

	    


       
    }
  
})();